module.exports = __webpack_public_path__ + "img/image22.2c8ce264.jpg";